export const url =
  process.env.REACT_APP_APP_ENV === 'prod'
    ? 'https://star-api.clpick.com'
    : 'https://star-api-dev.clpick.com';
